export const messages = Object.freeze({
    cannot_cancel_task: 'This task cannot be cancelled in its current state. Check its status in the task manager.',
    celery_task_exception: 'The background task failed. Please try again or contact support.',
    current_reqid_not_set: 'Your session is invalid. Please sign in again.',
    current_tkid_not_set: 'Your session is invalid. Please sign in again.',
    invalid_filter_value_type: 'Invalid filter value type. Please check your input and try again.',
    task_missing: 'The task is missing or could not be found.',
    task_not_found: 'The requested task could not be found.',
    task_submitter_not_task_creator: 'The task submitter is not task creator.',
    task_type_disabled: 'This operation is temporarily disabled. Please try again later.',
    tasks_disabled_for_user: 'Background tasks are disabled for your account. Please contact support.',
    tkid_is_none: 'A required task value is missing from the request.',
    ucid_not_found: 'The requested user connection could not be found.',
    unidentifiable_task_request: 'The request could not be processed because a required identifier is missing.'
})

export const dialogs = Object.freeze({})
